import React from 'react';
import Seo from '../components/Seo';

function Colaboraciones() {
  return (
    <div className="page">
      <Seo title="Colaboraciones" description="Portfolio de colaboraciones con editoriales, escritores, agencias y marcas." />
      <h1>Colaboraciones</h1>
      <p className="page__intro">Han confiado en Libros para Viajeros.</p>
      <p className="empty-state">
        Todavía no hay colaboraciones publicadas. La tabla `collaborations` ya existe — se mostrarán aquí
        únicamente colaboraciones reales en cuanto se publique la primera.
      </p>
    </div>
  );
}

export default Colaboraciones;
